/* eslint-disable */

import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { BarLoader, Button } from "../../../../shared/widgets";
import { templateStrings } from "../../../../Constant";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { passDetailsAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { exportExcel } from "../../../../shared/utils";

class MobileTicketDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter !== this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter !== this.props.operatorFilter)
      || (prevProps && prevProps.dateFilter !== this.props.dateFilter)
    ) {
      this.getList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  handleAction = (details) => {
    const { history } = this.props;
    history.push("/report/pass/revenue-distribution", details);
  };

  downloadExcel = async () => {
    const id = "exportPassDetails";
    const addOnFilter = {
      date: {
        fromDate: new Date(
          get(this, "props.location.state.fromDate", null),
        ).getTime(),
        toDate: new Date(
          get(this, "props.location.state.toDate", null),
        ).getTime(),
      },
      cityId: get(this, "props.location.state.cityId", ""),
    };
    await exportExcel({ id, addOnFilter });
  };

  getList = () => {
    if (
      get(this, "props.location.state.fromDate", null)
      && get(this, "props.location.state.toDate", null)
    ) {
      this.props.fetchPassDetails(
        {
          pageNo: this.state.pageNo,
          pageSize: this.state.rowsPerPage,
          dateFilter: {
            fromDate: new Date(
              get(this, "props.location.state.fromDate", null),
            ).getTime(),
            toDate: new Date(
              get(this, "props.location.state.toDate", null),
            ).getTime(),
          },
          cityId: get(this, "props.location.state.cityId", ""),
          operatorFilter: this.props.operatorFilter,
          sortBy: this.state.sortBy,
        },
        "header",
      );
    } else {
      const { history } = this.props;
      history.push("/report/mobile-ticket");
    }
  };

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.reportPassDetails;
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header
            heading="Pass Details"
            showBackArrow
            hideS
          >
            <div className="btn-wrapper">
              <Button
                disable={false}
                onClick={() => {
                  this.downloadExcel();
                }}
                buttonText="Export"
              />
            </div>
          </PageWrapper.Header>
          <BarLoader scope="header" />
          <TableWrapper
            content={!headerLoader && content}
            pageNo={pageNo}
            selected={selected}
            uniqueKey="uniqKey"
            rowsPerPage={rowsPerPage}
            count={totalItems}
            templateString={templateString}
            selectionAllowed={false}
            sortBy={sortBy}
            handleChange={this.handleChange}
            onSortToggle={this.onSortToggle}
            handleAction={this.handleAction}
          />
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Report
        && state.Report.passDetails
        && state.Report.passDetails.data)
      || [],
    totalItems:
      (state
        && state.Report
        && state.Report.passDetails
        && state.Report.passDetails.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchPassDetails: (value, loaderScope) => {
    dispatch(passDetailsAction(value, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileTicketDetails);
